// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    v2PublicGetReferenceCurrencies (params?: {}): Promise<Dict>;
    v2PublicGetMarketStatus (params?: {}): Promise<Dict>;
    v2PrivateGetAccountLedger (params?: {}): Promise<Dict>;
    v2PrivateGetAccountWithdrawQuota (params?: {}): Promise<Dict>;
    v2PrivateGetAccountWithdrawAddress (params?: {}): Promise<Dict>;
    v2PrivateGetAccountDepositAddress (params?: {}): Promise<Dict>;
    v2PrivateGetAccountRepayment (params?: {}): Promise<Dict>;
    v2PrivateGetReferenceTransactFeeRate (params?: {}): Promise<Dict>;
    v2PrivateGetAccountAssetValuation (params?: {}): Promise<Dict>;
    v2PrivateGetPointAccount (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserUserList (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserUserState (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserAccountList (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserDepositAddress (params?: {}): Promise<Dict>;
    v2PrivateGetSubUserQueryDeposit (params?: {}): Promise<Dict>;
    v2PrivateGetUserApiKey (params?: {}): Promise<Dict>;
    v2PrivateGetUserUid (params?: {}): Promise<Dict>;
    v2PrivateGetAlgoOrdersOpening (params?: {}): Promise<Dict>;
    v2PrivateGetAlgoOrdersHistory (params?: {}): Promise<Dict>;
    v2PrivateGetAlgoOrdersSpecific (params?: {}): Promise<Dict>;
    v2PrivateGetC2cOffers (params?: {}): Promise<Dict>;
    v2PrivateGetC2cOffer (params?: {}): Promise<Dict>;
    v2PrivateGetC2cTransactions (params?: {}): Promise<Dict>;
    v2PrivateGetC2cRepayment (params?: {}): Promise<Dict>;
    v2PrivateGetC2cAccount (params?: {}): Promise<Dict>;
    v2PrivateGetEtpReference (params?: {}): Promise<Dict>;
    v2PrivateGetEtpTransactions (params?: {}): Promise<Dict>;
    v2PrivateGetEtpTransaction (params?: {}): Promise<Dict>;
    v2PrivateGetEtpRebalance (params?: {}): Promise<Dict>;
    v2PrivateGetEtpLimit (params?: {}): Promise<Dict>;
    v2PrivatePostAccountTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostAccountRepayment (params?: {}): Promise<Dict>;
    v2PrivatePostPointTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserManagement (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserCreation (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserTradableMarket (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserTransferability (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserApiKeyGeneration (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserApiKeyModification (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserApiKeyDeletion (params?: {}): Promise<Dict>;
    v2PrivatePostSubUserDeductMode (params?: {}): Promise<Dict>;
    v2PrivatePostAlgoOrders (params?: {}): Promise<Dict>;
    v2PrivatePostAlgoOrdersCancelAllAfter (params?: {}): Promise<Dict>;
    v2PrivatePostAlgoOrdersCancellation (params?: {}): Promise<Dict>;
    v2PrivatePostC2cOffer (params?: {}): Promise<Dict>;
    v2PrivatePostC2cCancellation (params?: {}): Promise<Dict>;
    v2PrivatePostC2cCancelAll (params?: {}): Promise<Dict>;
    v2PrivatePostC2cRepayment (params?: {}): Promise<Dict>;
    v2PrivatePostC2cTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostEtpCreation (params?: {}): Promise<Dict>;
    v2PrivatePostEtpRedemption (params?: {}): Promise<Dict>;
    v2PrivatePostEtpTransactIdCancel (params?: {}): Promise<Dict>;
    v2PrivatePostEtpBatchCancel (params?: {}): Promise<Dict>;
    marketGetHistoryKline (params?: {}): Promise<Dict>;
    marketGetDetailMerged (params?: {}): Promise<Dict>;
    marketGetDepth (params?: {}): Promise<Dict>;
    marketGetTrade (params?: {}): Promise<Dict>;
    marketGetHistoryTrade (params?: {}): Promise<Dict>;
    marketGetDetail (params?: {}): Promise<Dict>;
    marketGetTickers (params?: {}): Promise<Dict>;
    marketGetEtp (params?: {}): Promise<Dict>;
    publicGetCommonSymbols (params?: {}): Promise<Dict>;
    publicGetCommonCurrencys (params?: {}): Promise<Dict>;
    publicGetCommonTimestamp (params?: {}): Promise<Dict>;
    publicGetCommonExchange (params?: {}): Promise<Dict>;
    publicGetSettingsCurrencys (params?: {}): Promise<Dict>;
    publicGetRetailMaintainTime (params?: {}): Promise<Dict>;
    privateGetAccountAccounts (params?: {}): Promise<Dict>;
    privateGetAccountAccountsIdBalance (params?: {}): Promise<Dict>;
    privateGetAccountAccountsSubUid (params?: {}): Promise<Dict>;
    privateGetAccountHistory (params?: {}): Promise<Dict>;
    privateGetCrossMarginLoanInfo (params?: {}): Promise<Dict>;
    privateGetMarginLoanInfo (params?: {}): Promise<Dict>;
    privateGetFeeFeeRateGet (params?: {}): Promise<Dict>;
    privateGetOrderOpenOrders (params?: {}): Promise<Dict>;
    privateGetOrderOrders (params?: {}): Promise<Dict>;
    privateGetOrderOrdersId (params?: {}): Promise<Dict>;
    privateGetOrderOrdersIdMatchresults (params?: {}): Promise<Dict>;
    privateGetOrderOrdersGetClientOrder (params?: {}): Promise<Dict>;
    privateGetOrderHistory (params?: {}): Promise<Dict>;
    privateGetOrderMatchresults (params?: {}): Promise<Dict>;
    privateGetQueryDepositWithdraw (params?: {}): Promise<Dict>;
    privateGetMarginLoanOrders (params?: {}): Promise<Dict>;
    privateGetMarginAccountsBalance (params?: {}): Promise<Dict>;
    privateGetCrossMarginLoanOrders (params?: {}): Promise<Dict>;
    privateGetCrossMarginAccountsBalance (params?: {}): Promise<Dict>;
    privateGetPointsActions (params?: {}): Promise<Dict>;
    privateGetPointsOrders (params?: {}): Promise<Dict>;
    privateGetSubuserAggregateBalance (params?: {}): Promise<Dict>;
    privateGetStableCoinExchangeRate (params?: {}): Promise<Dict>;
    privateGetStableCoinQuote (params?: {}): Promise<Dict>;
    privateGetRetailOrderList (params?: {}): Promise<Dict>;
    privatePostAccountTransfer (params?: {}): Promise<Dict>;
    privatePostFuturesTransfer (params?: {}): Promise<Dict>;
    privatePostOrderBatchOrders (params?: {}): Promise<Dict>;
    privatePostOrderOrdersPlace (params?: {}): Promise<Dict>;
    privatePostOrderOrdersSubmitCancelClientOrder (params?: {}): Promise<Dict>;
    privatePostOrderOrdersBatchCancelOpenOrders (params?: {}): Promise<Dict>;
    privatePostOrderOrdersIdSubmitcancel (params?: {}): Promise<Dict>;
    privatePostOrderOrdersBatchcancel (params?: {}): Promise<Dict>;
    privatePostDwWithdrawApiCreate (params?: {}): Promise<Dict>;
    privatePostDwWithdrawVirtualIdCancel (params?: {}): Promise<Dict>;
    privatePostDwTransferInMargin (params?: {}): Promise<Dict>;
    privatePostDwTransferOutMargin (params?: {}): Promise<Dict>;
    privatePostMarginOrders (params?: {}): Promise<Dict>;
    privatePostMarginOrdersIdRepay (params?: {}): Promise<Dict>;
    privatePostCrossMarginTransferIn (params?: {}): Promise<Dict>;
    privatePostCrossMarginTransferOut (params?: {}): Promise<Dict>;
    privatePostCrossMarginOrders (params?: {}): Promise<Dict>;
    privatePostCrossMarginOrdersIdRepay (params?: {}): Promise<Dict>;
    privatePostStableCoinExchange (params?: {}): Promise<Dict>;
    privatePostSubuserTransfer (params?: {}): Promise<Dict>;
    privatePostRetailOrderPlace (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
